import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=45311f07&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=45311f07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45311f07",
  null
  
)

export default component.exports